// src/boot/canny.js
export default (function (_ref) {
  var Vue = _ref.Vue;

  function loadCannyScript() {
    if (!document.getElementById('canny-jssdk')) {
      var firstScript = document.getElementsByTagName('script')[0];
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://canny.io/sdk.js';
      firstScript.parentNode.insertBefore(script, firstScript);
    }
  }

  if (typeof window.Canny !== 'function') {
    window.Canny = function () {
      window.Canny.q.push(arguments);
    };

    window.Canny.q = [];

    if (document.readyState === 'complete') {
      loadCannyScript();
    } else {
      if (window.attachEvent) {
        window.attachEvent('onload', loadCannyScript);
      } else {
        window.addEventListener('load', loadCannyScript, false);
      }
    }
  }
});